import { englishError } from "../utils/databaseErrors";
import React, { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";
import { COMPANIES, companyCodesForUser } from "../utils/companies";

// Popup Modal reusable component
function PopupModal({ children, onClose }) {
  return (
    <div className="ui-backdrop"
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(81,69,54,0.16)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 2001,
      }}
      onClick={onClose}
    >
      <div className="ui-modal ui-modal-small"
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#faf8f4",
          borderRadius: 12,
          minWidth: 380,
          padding: 24,
          boxShadow: "0 0 30px #51453644",
          direction: "ltr",
          maxWidth: "97vw",
          fontFamily: "Jost, 'Trebuchet MS', Arial, sans-serif",
        }}
      >
        {children}
      </div>
    </div>
  );
}

function EmployeeTable() {
  const [employees, setEmployees] = useState([]);
  const [showrooms, setShowrooms] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [form, setForm] = useState({
    name: "",
    username: "",
    password: "",
    phone: "",
    job_title: "",
    showroom_id: "",
    company_codes: ["abbas_halim"],
  });
  const [editId, setEditId] = useState(null);

  useEffect(() => {
    fetchAll();
  }, []);

  async function fetchAll() {
    const [{ data: empData }, { data: showroomData }] = await Promise.all([
      supabase.from("employee").select("*").order("id"),
      supabase.from("showroom").select("id, name"),
    ]);
    setEmployees(empData || []);
    setShowrooms(showroomData || []);
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!form.name || !form.username || (!editId && !form.password) || !form.showroom_id)
      return alert(
        "Complete all required fields (Name, Username, Password, Showroom)"
      );
    if (!form.company_codes.length) return alert("Assign at least one company to this employee.");

    let toSend = {
      name: form.name,
      username: form.username,
      ...(form.password ? { password_hash: form.password } : {}),
      phone: form.phone,
      job_title: form.job_title,
      showroom_id: Number(form.showroom_id),
      company_codes: form.company_codes,
    };

    const result = !editId ? await supabase.from("employee").insert([toSend]) : await supabase.from("employee").update(toSend).eq("id", editId);
    if (result.error) return alert("Unable to save the employee: " + englishError(result.error.message));
    setForm({
      name: "",
      username: "",
      password: "",
      phone: "",
      job_title: "",
      showroom_id: "",
      company_codes: ["abbas_halim"],
    });
    setEditId(null);
    setShowPopup(false);
    fetchAll();
  }

  function handleEdit(emp) {
    setForm({
      name: emp.name || "",
      username: emp.username || "",
      password: "",
      phone: emp.phone || "",
      job_title: emp.job_title || "",
      showroom_id: emp.showroom_id ? String(emp.showroom_id) : "",
      company_codes: companyCodesForUser(emp),
    });
    setEditId(emp.id);
    setShowPopup(true);
  }

  async function handleDelete(id) {
    if (!window.confirm("Delete this employee?")) return;
    await supabase.from("employee").delete().eq("id", id);
    fetchAll();
  }

  const showroomLookup = Object.fromEntries(
    showrooms.map((s) => [s.id, s.name])
  );

  const thStyle = {
    padding: "8px 12px",
    borderBottom: "1.5px solid #d2cbc1",
    background: "#f2ede4",
    fontWeight: "bold",
    fontSize: 13,
    textAlign: "left",
    whiteSpace: "nowrap",
  };

  const tdStyle = {
    padding: "8px 12px",
    fontSize: 13,
    textAlign: "left",
    verticalAlign: "middle",
    background: "#faf8f4",
    borderBottom: "1px solid var(--line, #d2cbc1)",
  };

  const btnStyle = {
    padding: "6px 16px",
    borderRadius: 6,
    cursor: "pointer",
    border: "none",
    fontWeight: "bold",
    fontSize: 14,
  };

  const inputStyle = {
    width: "175px",
    marginBottom: 10,
    padding: "8px 10px",
    textAlign: "left",
    fontSize: 14,
    borderRadius: 6,
    border: "1px solid #d2cbc1",
  };

  return (
    <div className="ui-legacy-page"
      dir="ltr"
      style={{
        maxWidth: 900,
        margin: "auto",
        fontFamily: "Jost, 'Trebuchet MS', Arial, sans-serif",
        padding: 24,
        background: "#f2ede4",
        borderRadius: 14,
        boxShadow: "0 2px 12px #51453610",
        minHeight: "100vh",
        textAlign: "left",
      }}
    >
      <div className="ui-page-header"><h2 style={{ marginBottom: 18, color: "var(--accent, #514536)" }}>Employees</h2>
      <button className="ui-primary"
        onClick={() => {
          setForm({
            name: "",
            username: "",
            password: "",
            phone: "",
            job_title: "",
            showroom_id: "",
            company_codes: ["abbas_halim"],
          });
          setEditId(null);
          setShowPopup(true);
        }}
        style={{
          marginBottom: 20,
          padding: "10px 28px",
          background: "var(--accent, #514536)",
          color: "#faf8f4",
          border: "none",
          borderRadius: 8,
          fontWeight: "bold",
          fontSize: 16,
          cursor: "pointer",
        }}
      >
        Add employee
      </button></div>
      <div className="ui-table-scroll"><table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          direction: "ltr",
          background: "#faf8f4",
          borderRadius: 12,
          boxShadow: "0 1px 10px #51453610",
          fontSize: 13,
        }}
      >
        <thead>
          <tr style={{ background: "#f2ede4", color: "var(--accent, #514536)" }}>
            <th style={thStyle}>#</th>
            <th style={thStyle}>Name</th>
            <th style={thStyle}>Username</th>
            <th style={thStyle}>Phone number</th>
            <th style={thStyle}>Job title</th>
            <th style={thStyle}>Showroom</th>
            <th style={thStyle}>Companies</th>
            <th style={thStyle}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {employees.map((e, i) => (
            <tr key={e.id}>
              <td style={tdStyle}>{i + 1}</td>
              <td style={tdStyle}>{e.name}</td>
              <td style={tdStyle}>{e.username}</td>
              <td style={tdStyle}>{e.phone}</td>
              <td style={tdStyle}>{e.job_title}</td>
              <td style={tdStyle}>{showroomLookup[e.showroom_id] || "-"}</td>
              <td style={tdStyle}>{companyCodesForUser(e).map((code) => COMPANIES[code].name).join(", ") || "Unassigned"}</td>
              <td style={{ ...tdStyle, whiteSpace: "nowrap" }}><div className="ui-actions">
                <button className="ui-primary"
                  onClick={() => handleEdit(e)}
                  style={{
                    ...btnStyle,
                    marginLeft: 8,
                    backgroundColor: "var(--accent, #514536)",
                    color: "#faf8f4",
                  }}
                >
                  Edit
                </button>
                <button className="ui-secondary"
                  onClick={() => handleDelete(e.id)}
                  style={{ ...btnStyle, background: "none", color: "#514536" }}
                >
                  Delete
                </button>
              </div></td>
            </tr>
          ))}
          {employees.length === 0 && (
            <tr>
              <td
                colSpan={8}
                style={{ color: "#716759", textAlign: "center", padding: 20 }}
              >
                No employees yet
              </td>
            </tr>
          )}
        </tbody>
      </table></div>

      {/* Popup لإضافة أو تعديل موظف */}
      {showPopup && (
        <PopupModal
          onClose={() => {
            setShowPopup(false);
            setEditId(null);
          }}
        >
          <form className="ui-form" onSubmit={handleSubmit} style={{ direction: "ltr" }}>
            <div className="ui-fields" style={{ display: "flex", gap: 12, marginBottom: 12 }}>
              <label className="ui-field">Name<input
                required
                placeholder="Name"
                value={form.name}
                onChange={(e) =>
                  setForm((f) => ({ ...f, name: e.target.value }))
                }
                style={inputStyle}
              /></label>
              <label className="ui-field">Username<input
                required
                placeholder="Username"
                value={form.username}
                onChange={(e) =>
                  setForm((f) => ({ ...f, username: e.target.value }))
                }
                style={inputStyle}
              /></label>
            </div>
            <div className="ui-fields" style={{ display: "flex", gap: 12, marginBottom: 12 }}>
              <input
                required={!editId}
                placeholder={editId ? "New password (optional)" : "Password"}
                type="password"
                value={form.password}
                onChange={(e) =>
                  setForm((f) => ({ ...f, password: e.target.value }))
                }
                style={inputStyle}
              />
              <label className="ui-field">Phone number<input
                placeholder="Phone number"
                value={form.phone}
                onChange={(e) =>
                  setForm((f) => ({ ...f, phone: e.target.value }))
                }
                style={inputStyle}
              /></label>
            </div>
            <div className="ui-fields" style={{ display: "flex", gap: 12, marginBottom: 14 }}>
              <label className="ui-field">Job title<input
                placeholder="Job title"
                value={form.job_title}
                onChange={(e) =>
                  setForm((f) => ({ ...f, job_title: e.target.value }))
                }
                style={inputStyle}
              /></label>
              <label className="ui-field">Showroom<select
                required
                value={form.showroom_id}
                onChange={(e) =>
                  setForm((f) => ({ ...f, showroom_id: e.target.value }))
                }
                style={inputStyle}
              >
                <option value="">Select a showroom</option>
                {showrooms.map((s) => (
                  <option key={s.id} value={s.id}>
                    {s.name}
                  </option>
                ))}
              </select></label>
            </div>
            <fieldset style={{ marginBottom: 16, border: "1px solid #d2cbc1", borderRadius: 6 }}>
              <legend>Assigned companies</legend>
              {Object.values(COMPANIES).map((company) => <label key={company.code} style={{ display: "block", margin: 8 }}>
                <input type="checkbox" checked={form.company_codes.includes(company.code)} onChange={(event) => setForm((current) => ({ ...current, company_codes: event.target.checked ? [...current.company_codes, company.code] : current.company_codes.filter((code) => code !== company.code) }))} /> {company.name}
              </label>)}
              <p style={{ fontSize: 12 }}>Company assignments take effect at the next sign-in. Owners can access both companies.</p>
            </fieldset>
            <div className="ui-actions ui-form-actions" style={{ display: "flex", gap: 8, marginTop: 8 }}>
              <button className="ui-primary"
                type="submit"
                style={{
                  padding: "10px 28px",
                  background: "var(--accent, #514536)",
                  color: "#faf8f4",
                  border: "none",
                  borderRadius: 8,
                  fontWeight: "bold",
                  fontSize: 16,
                  cursor: "pointer",
                  flexGrow: 1,
                }}
              >
                {editId ? "Refresh" : "Save"}
              </button>
              <button className="ui-secondary"
                type="button"
                onClick={() => {
                  setShowPopup(false);
                  setEditId(null);
                }}
                style={{
                  background: "#d2cbc1",
                  color: "var(--accent, #514536)",
                  borderRadius: 8,
                  fontWeight: "bold",
                  border: "none",
                  padding: "10px 28px",
                  fontSize: 16,
                  cursor: "pointer",
                  flexGrow: 1,
                }}
              >
                Cancel
              </button>
            </div>
          </form>
        </PopupModal>
      )}
    </div>
  );
}

export default EmployeeTable;
